import React from "react";
import styled from "styled-components";

const CountryContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
`;

const FlagIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background: #e2e8f0;
  border-radius: 50%;
  flex-shrink: 0;
`;

const CountryText = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
`;

const UnknownText = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
  font-style: italic;
`;

const CountryFlagImage = styled.img`

  border-radius: 2px;
`;


const DishCountryInfo = ({countryName}) => {
  // Clean and decode the URL
  const cleanUrl = countryName ? 
    countryName
      .replace(/\\/g, '/')           // Replace escaped slashes
      .replace(/"/g, '')            // Remove quotes
      .replace(/^@/, '')             // Remove @ symbol at the beginning
      .trim()                       // Remove whitespace
      .replace(/\s+/g, '')          // Remove any remaining spaces
    : null;

    console.log("cleanUrl", cleanUrl);
  
  return (
    <CountryContainer>
      {cleanUrl ? (
        <>
          <CountryFlagImage 
            src={cleanUrl} 
            alt="Country Flag" 
            className="w-auto h-4"
            onError={(e) => {
              console.error("Failed to load flag image:", cleanUrl);
              e.target.style.display = 'none';
            }}
          />
          <CountryText>{cleanUrl?.split("/flags/").pop().split(".")[0].toUpperCase()}</CountryText>
        </>
      ) : (
        <>
          <FlagIcon>
            🌍
          </FlagIcon>
          <UnknownText>Ej angivet</UnknownText>
        </>
      )}
    </CountryContainer>
  );
};

export default DishCountryInfo;
